import React from "react";

export default function SgcFiltroSection({
  icon,
  label,
  children,
  className = "",
}) {
  return (
    <div className={`sgc-filtro-block${className ? ` ${className}` : ""}`}>
      <div className="sgc-filtro-label">
        {icon ? <i className={`bi bi-${icon}`} aria-hidden /> : null}
        <span>{label}</span>
      </div>
      {children}
    </div>
  );
}
